<template>
  <a-layout class="promotion">
    <TitleBreadcrumb />
    <div class="content-base container">
      <a-row type="flex" justify="space-between" :gutter="[16, 16]">
        <a-col :span="24">
          <h2 class="promotion-title">
            {{ labels.subtitle }}
          </h2>
        </a-col>
      </a-row>

      <!-- PROMOTION RAFFLES -->
      <a-row
        v-if="currentRaffle || loadingDaily"
        class="promotion-row"
        type="flex"
        justify="center"
        :gutter="[16, 16]"
      >
        <a-col :xs="24" :sm="24" :md="16" :lg="16">
          <a-card :loading="loadingDaily" class="promotion-card-flex">
            <template v-if="currentRaffle">
              <!-- DAILY RAFFLE -->
              <div class="raffle-item max-width">
                <div class="raffle-item-image">
                  <a-icon class="custom-image" type="trophy" />
                </div>
                <div class="raffle-item-content">
                  <div class="raffle-item-content-title">
                    {{ labels.dailyRaffle.title }}
                  </div>
                  <div class="raffle-item-content-title2">
                    {{ currentRaffle.title }}
                  </div>
                  <div class="raffle-item-content-subtitle">
                    {{
                      currentRaffle.type === "cash"
                        ? labels.dailyRaffle.subtitle
                        : labels.dailyRaffle.subtitle2
                    }}
                  </div>
                  <div class="raffle-item-content-prize">
                    <span v-if="currentRaffle.type === 'cash'">{{
                      currentRaffle.prize | currency
                    }}</span>
                    <span v-else :title="currentRaffle.prize">
                      {{ currentRaffle.prize | titleLimited(30) }}
                      <a-tooltip placement="bottom" trigger="click">
                        <template slot="title">
                          <h3>{{ currentRaffle.prize }}</h3>
                          <p>{{ currentRaffle.description }}</p>
                        </template>
                        <a-icon type="info-circle" />
                      </a-tooltip>
                    </span>
                  </div>
                </div>
              </div>
              <div class="raffle-item min-width">
                <countdown-component
                  v-if="!changing"
                  :time="
                    $options.filters.dateTimeToMilliseconds(
                      getTimeOut(currentRaffle)
                    )
                  "
                  class="text-muted"
                >
                  <template v-slot="{ hours, minutes, seconds }">
                    <!-- TIMES -->
                    <div class="raffle-item-times">
                      <div class="raffle-item-times-title">
                        {{ labels.dailyRaffle.timeout }}
                      </div>
                      <div class="raffle-item-times-content">
                        <!-- HOURS, MINUTES, SECONDS -->
                        <span class="raffle-item-times-content-times">
                          <span class="raffle-item-times-content-times-value">{{
                            hours | countDownFormat
                          }}</span>
                          <span class="raffle-item-times-content-times-label">{{
                            labels.dailyRaffle.hour
                          }}</span>
                        </span>
                        <span class="raffle-item-times-content-times">
                          <span class="raffle-item-times-content-times-value">{{
                            minutes | countDownFormat
                          }}</span>
                          <span class="raffle-item-times-content-times-label">{{
                            labels.dailyRaffle.minute
                          }}</span>
                        </span>
                        <span class="raffle-item-times-content-times">
                          <span class="raffle-item-times-content-times-value">{{
                            seconds | countDownFormat
                          }}</span>
                          <span class="raffle-item-times-content-times-label">{{
                            labels.dailyRaffle.second
                          }}</span>
                        </span>
                      </div>
                    </div>
                  </template>
                </countdown-component>
              </div>
              <!-- ARROWS -->
              <div v-if="daily.raffles.length > 1" class="raffle-item-arrows">
                <a-icon
                  @click.stop.prevent="prevRaffle"
                  class="raffle-item-arrow"
                  type="left"
                  :class="{ disabled: !prevEnabled }"
                />
                <a-icon
                  @click.stop.prevent="nextRaffle"
                  class="raffle-item-arrow"
                  type="right"
                  :class="{ disabled: !nextEnabled }"
                />
              </div>
            </template>
          </a-card>
        </a-col>

        <a-col
          v-if="daily && daily.last_winner"
          :xs="24"
          :sm="24"
          :md="8"
          :lg="8"
        >
          <a-card :loading="loadingDaily" class="promotion-card-flex">
            <div v-if="daily && daily.last_winner" class="raffle-last-winner">
              <div class="raffle-last-winner-title">
                {{ labels.lasWinner.title }}
              </div>
              <div class="raffle-last-winner-content">
                <div class="raffle-last-winner-content-image">
                  <a-icon type="user" />
                </div>
                <div class="raffle-last-winner-content-info">
                  <span class="raffle-last-winner-content-info-name">
                    {{ daily.last_winner.name || "Anónimo" }}
                  </span>
                  <span class="raffle-last-winner-content-info-prize">
                    <span v-if="daily.last_winner.type === 'cash'">
                      {{ daily.last_winner.prize | currency }}
                    </span>
                    <span v-else-if="daily.last_winner.type === 'product'">
                      {{ daily.last_winner.product_name }}
                    </span>
                  </span>
                  <span
                    v-if="daily.last_winner.date"
                    class="raffle-last-winner-content-info-date"
                  >
                    {{
                      $moment(
                        daily.last_winner.date,
                        FORMAT.SERVER_DATE_TIME
                      ).format(FORMAT.MOMENT_DATE)
                    }}
                  </span>
                </div>
              </div>
            </div>
          </a-card>
        </a-col>
        <a-col
          v-else-if="
            !loadingDaily &&
            daily &&
            !daily.last_winner &&
            daily.raffles.length > 0
          "
          :xs="24"
          :sm="24"
          :md="8"
          :lg="8"
        >
          <a-card class="promotion-card-flex">
            <div class="raffle-last-winner">
              <div class="raffle-last-winner-title">
                {{ labels.lasWinner.title }}
              </div>
              <div class="raffle-last-winner-content">
                <div class="raffle-last-winner-content-image">
                  <a-icon type="user" />
                </div>
                <div class="raffle-last-winner-content-info">
                  <span class="raffle-last-winner-content-info-name">
                    {{ "Anónimo" }}
                  </span>
                  <span class="raffle-last-winner-content-info-prize">
                    <span>
                      {{ 15000 | currency }}
                    </span>
                  </span>
                  <span class="raffle-last-winner-content-info-date">
                    {{
                      $moment().subtract(1, "day").format(FORMAT.MOMENT_DATE)
                    }}
                  </span>
                </div>
              </div>
            </div>
          </a-card>
        </a-col>
        <a-col
          v-else-if="
            !loadingDaily &&
            daily &&
            !daily.last_winner &&
            daily.raffles.length > 0
          "
          :xs="24"
          :sm="24"
          :md="8"
          :lg="8"
        >
          <a-card class="promotion-card-flex">
            <div class="raffle-last-winner">
              <div class="raffle-last-winner-title">
                {{ labels.lasWinner.title }}
              </div>
              <div class="raffle-last-winner-content">
                <div class="raffle-last-winner-content-image">
                  <a-icon type="user" />
                </div>
                <div class="raffle-last-winner-content-info">
                  <span class="raffle-last-winner-content-info-name">
                    {{ "Anónimo" }}
                  </span>
                  <span class="raffle-last-winner-content-info-prize">
                    <span>
                      {{ 15000 | currency }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </a-card>
        </a-col>
      </a-row>

      <!-- RERERRAL BY LEVEL -->
      <a-card class="promotion-card">
        <a-row type="flex" justify="center" :gutter="[16, 16]">
          <a-col :span="24" class="promotion-card-content">
            <h3 class="promotion-card-title">
              {{ labels.table.title }}
              <span>{{ labels.table.subtitle }}</span>
            </h3>
            <StandardTable
              class="table-base"
              ref="standardTable"
              :fetchService="getUserPromotionRaffles"
              :columns="columns"
              :locale="locale"
              :scroll="{ x: isMobile ? true : false }"
              :rowKey="'id'"
              :paginationType="isMobile ? 'arrows' : 'numbers'"
            />
          </a-col>
        </a-row>
      </a-card>

      <!-- APPLY PROMOTION FORM -->
      <a-card class="promotion-card">
        <a-row type="flex" justify="center" :gutter="[16, 16]">
          <a-col :span="24" class="promotion-card-content">
            <h3 class="promotion-subtitle">
              {{ labels.promotionForm.title }}
              <span>{{ labels.promotionForm.subtitle }}</span>
            </h3>
          </a-col>
          <a-col :span="24" class="promotion-card-content">
            <!-- FORM -->
            <ValidationObserver ref="observer">
              <a-form
                :label-width="80"
                slot-scope="{ validate }"
                @submit.prevent="validate().then(handleSubmitPromotion)"
              >
                <div class="promotion-card-content-form">
                  <Input
                    v-model="promotionCode"
                    class="promotion-input"
                    type="text"
                    rules="required"
                    vid="code"
                    :placeholder="labels.promotionForm.code.placeholder"
                    :allowClear="true"
                    :label="labels.promotionForm.code.label"
                    @keyup.enter.native="validate().then(handleSubmitPromotion)"
                    @input="onlyAlfaUpperCaseCode($event)"
                  />

                  <a-form-item style="text-align: right">
                    <a-button
                      type="default"
                      html-type="submit"
                      :loading="submitting"
                      class="promotion-button"
                      :disabled="submitting"
                    >
                      {{ labels.promotionForm.submit }}
                    </a-button>
                  </a-form-item>
                </div>
              </a-form>
            </ValidationObserver>
          </a-col>
        </a-row>
      </a-card>
    </div>
  </a-layout>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import TitleBreadcrumb from "@/components/layout/client/TitleBreadcrumb.vue";
import StandardTable from "@/components/core/table/StandardTable.vue";
import Input from "@/components/core/VeeValidateForm/Input";
import loadingMixin from "@/mixins/loadingMixin";
import { pageTitle, DATE_FORMAT } from "../../utils/utils";
import labels from "@/utils/labels";
import { mapActions, mapGetters } from "vuex";
import { formatMoney } from "accounting";
import moment from "moment-timezone";
import CountdownComponent from "@/components/CountdownComponent.vue";
import { cloneDeep } from "lodash";
import { nextTick } from "vue";
export default {
  components: {
    TitleBreadcrumb,
    ValidationObserver,
    Input,
    StandardTable,
    CountdownComponent,
  },
  name: "promotion",
  mixins: [loadingMixin],
  metaInfo: {
    title: pageTitle(labels.promotionsPage.subtitle),
    meta: [
      {
        name: "title",
        content: labels.appName,
      },
      {
        name: "description",
        content: labels.promotionsPage.subtitle,
      },
    ],
  },
  filters: {
    currency(value) {
      return formatMoney(value, {
        symbol: " DOP",
        format: "%v%s",
        decimal: ".",
        thousand: ",",
        precision: 2,
      });
    },
    titleLimited(value, limit = 30) {
      if (!value) return "";
      return value.length > limit ? value.substring(0, limit) + "..." : value;
    },
    dateTimeToMilliseconds(value) {
      const date = moment(value, DATE_FORMAT.MOMENT_DATE_TIME);
      return date.diff(moment(), "milliseconds", true);
    },
    countDownFormat(value) {
      if (value < 0) {
        return "--";
      }
      return value.toString().padStart(2, "0");
    },
  },
  data() {
    return {
      labels: labels.promotionsPage,
      promotionCode: "",
      submitting: false,
      loading: false,
      loadingDaily: false,
      daily: null,
      currentRaffle: null,
      intervalId: null,
      changing: false,
      FORMAT: DATE_FORMAT,
    };
  },
  created() {
    this.handleGetDaily();
  },
  computed: {
    ...mapGetters({
      loggedUser: "clientAuth/getLoggedUser",
    }),
    locale() {
      return {
        emptyText: this.labels.table.emptyText,
      };
    },
    columns() {
      return [
        {
          title: this.labels.table.columns.title,
          dataIndex: "name",
          key: "name",
          hidden: this.isMobile,
        },
        {
          title: this.labels.table.columns.tickets,
          dataIndex: "tickets",
          key: "tickets",
          align: "center",
          width: 140,
          hidden: this.isMobile,
          customRender: (text, record) => {
            return (
              <a-button
                type="link"
                style="padding: 0"
                onClick={() => this.handleShowTickets(record)}
                title={this.labels.table.columns.ticketBtnTitle}
              >
                <a-badge
                  count={`Ver (${text})`}
                  number-style={{ backgroundColor: "var(--btn-bg-primary)" }}
                  showZero
                  offset={[0, 0]}
                  class="custom-badge"
                />
              </a-button>
            );
          },
        },
        {
          title: this.labels.table.columns.status.title,
          dataIndex: "status",
          key: "status",
          width: 140,
          hidden: this.isMobile,
          customRender: (text) => {
            return (
              <a-tag color={this.statusColor(text?.toLowerCase())}>
                {this.statusText(text?.toLowerCase())}
              </a-tag>
            );
          },
        },
        {
          title: this.labels.table.columns.promotionRaffles,
          dataIndex: "raffle",
          key: "raffle",
          width: 140,
          hidden: !this.isMobile,
          customRender: (_, record) => {
            // Card item design
            return (
              <div class="list-item">
                <div class="list-item-head">
                  <div class="list-item-head-content">
                    <div class="list-item-head-content-name">
                      <span>{record.name}</span>
                    </div>
                  </div>
                  <div class="list-item-head-footer">
                    <div class="list-item-head-footer-tickets">
                      <a-button
                        type="link"
                        style="padding: 0"
                        onClick={() => this.handleShowTickets(record)}
                        title={this.labels.table.columns.ticketBtnTitle}
                      >
                        <a-badge
                          count={`Boletos (${record.tickets})`}
                          number-style={{
                            backgroundColor: "var(--btn-bg-primary)",
                          }}
                          showZero
                          offset={[0, 0]}
                          class="custom-badge"
                        />
                      </a-button>
                    </div>
                    <div class="list-item-head-footer-status">
                      <a-tag
                        color={this.statusColor(record.status?.toLowerCase())}
                      >
                        {this.statusText(record.status?.toLowerCase())}
                      </a-tag>
                    </div>
                  </div>
                </div>
              </div>
            );
          },
        },
      ].filter((column) => !column.hidden);
    },
    nextEnabled() {
      return this.currentRaffle?.index < this.daily?.raffles.length - 1;
    },
    prevEnabled() {
      return this.currentRaffle?.index > 0;
    },
  },
  methods: {
    ...mapActions("clientAuth", ["applyPromotion"]),
    ...mapActions("promotionRaffles", [
      "getUserPromotionRaffles",
      "getUserPromotionRaffleTickets",
      "getDaily",
    ]),
    async onlyAlfaUpperCaseCode(value) {
      this.promotionCode = await value
        .replace(/[^A-Z0-9a-z]/g, "")
        .toUpperCase();
    },
    getTimeOut(raffle) {
      const endDateTime = moment
        .tz(
          raffle.limited_date,
          DATE_FORMAT.SERVER_DATE_TIME,
          raffle.timezone || DATE_FORMAT.TIMEZONE
        )
        .tz(DATE_FORMAT.TIMEZONE)
        .format(DATE_FORMAT.MOMENT_DATE_TIME);
      return endDateTime;
    },
    async handleSubmitPromotion() {
      if (this.submitting) return;
      try {
        this.submitting = true;
        await this.applyPromotion(this.promotionCode);
        this.$message.success(this.labels.promotionForm.appliedSuccess);
      } catch (error) {
        if (error.isAxiosError && error.response?.status === 400) {
          this.$notification["error"]({
            message:
              error.response?.data?.message || labels.promotionForm.formError,
            description: (h) => {
              return h(
                "ul",
                error.response?.data?.additional_errors?.map((error) => {
                  return h("li", error);
                })
              );
            },
          });
        } else if (error.isAxiosError && error.response?.status === 409) {
          this.$message.info(
            error?.response?.data?.message ||
              error?.response?.message ||
              this.labels.appliedError
          );
        } else {
          this.$message.error(
            error?.response?.data?.message ||
              error?.response?.message ||
              this.labels.appliedError
          );
        }
      } finally {
        this.submitting = false;
      }
    },
    async handleShowTickets(record) {
      if (this.loading) return;
      try {
        this.loading = true;
        const { data: { data: tickets } = {} } =
          await this.getUserPromotionRaffleTickets({
            raffleId: record.id,
          });
        // SHOW NOTIFICATION MODAL AS TABLE WITH COLUMNS ticket_number, date and transaction or order link
        const modalInfo = this.$info({
          title: this.labels.table.ticketsTitle,
          width: this.isMobile ? "100%" : 600,
          okText: this.labels.table.okText,
          okType: "default",
          class: "custom-promotion-modal",
          icon: "tag",
          content: (h) => {
            return h(
              "a-table",
              {
                props: {
                  dataSource: tickets,
                  pagination: false,
                  rowKey: "id",
                  size: "small",
                  columns: [
                    {
                      title: this.labels.table.columns.ticketNumber,
                      dataIndex: "ticket_number",
                      key: "ticket_number",
                    },
                    {
                      title: this.labels.table.columns.date,
                      dataIndex: "date",
                      key: "date",
                      customRender: (text) => {
                        return text
                          ? this.$moment(text).format("DD/MM/YYYY")
                          : "-";
                      },
                    },
                    {
                      title: this.labels.table.columns.module,
                      dataIndex: "module",
                      key: "module",
                      customRender: (_, record) => {
                        return (
                          <a-button
                            type="link"
                            onClick={() => {
                              this.$router.push({
                                name: record?.transaction
                                  ? "transaction-view"
                                  : "ticket-view",
                                params: {
                                  code: record?.transaction
                                    ? record?.transaction?.code
                                    : record?.order?.number,
                                },
                              });
                              modalInfo.destroy();
                            }}
                            style="padding: 0"
                          >
                            {record?.transaction?.code || record?.order?.number}
                          </a-button>
                        );
                      },
                    },
                  ],
                },
              },
              tickets
            );
          },
        });
      } catch (error) {
        console.log(error);
        this.$message.error(
          error?.response?.data?.message ||
            error?.response?.message ||
            this.labels.appliedError
        );
      } finally {
        this.loading = false;
      }
    },
    async handleGetDaily() {
      if (this.loading) return;
      try {
        this.loadingDaily = true;
        const { data: { last_winner, raffles = [] } = {} } =
          await this.getDaily();
        this.daily = {
          last_winner,
          raffles: raffles,
        };
        if (raffles.length > 0) {
          this.currentRaffle = {
            index: 0,
            ...this.daily.raffles[0],
          };
        }
      } catch (error) {
        console.error(error);
        this.daily = null;
      } finally {
        this.loadingDaily = false;
      }
    },
    nextRaffle() {
      // Logic to go to the next raffle
      if (!this.nextEnabled) return;
      this.changing = true;
      const nextIndex = this.currentRaffle.index + 1;
      const raffle = cloneDeep(this.daily).raffles[nextIndex];
      this.currentRaffle = {
        index: nextIndex,
        ...raffle,
      };
      setTimeout(() => {
        nextTick(() => {
          this.changing = false;
        });
      }, 100);
    },
    prevRaffle() {
      // Logic to go to the previous raffle
      if (!this.prevEnabled) return;
      this.changing = true;
      const prevIndex = this.currentRaffle.index - 1;
      const raffle = this.daily.raffles[prevIndex];
      this.currentRaffle = {
        ...raffle,
        index: prevIndex,
      };
      setTimeout(() => {
        nextTick(() => {
          this.changing = false;
        });
      }, 100);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variable";
.promotion {
  max-width: 100% !important;
  font-family: "Roboto", sans-serif;
  background-color: transparent;
  .content-base {
    padding-top: 60px;
    @media screen and (max-width: $screen-mobile) {
      max-width: 100% !important;
      padding-top: 14px;
    }
  }
  &-title {
    font-size: 24px;
    font-weight: 500;
    color: var(--text);
    margin-bottom: 8px;
    text-align: center;
    &.small {
      font-size: 14px;
      color: var(--text);
      font-weight: 400;
      margin-bottom: 16px;
    }
  }
  &-subtitle {
    font-size: 16px;
    font-weight: 500;
    color: var(--text);
    margin-bottom: 0;
    span {
      display: block;
      font-size: 14px;
      color: var(--text);
      font-weight: 400;
    }
  }
  &-button {
    color: var(--btn-text-secondary);
    background-color: var(--btn-bg-secondary);
    border: 1px solid var(--btn-bc-secondary);
    margin-top: 44px;
    &:hover,
    &:active,
    &:focus {
      background-color: transparent;
    }
    @media screen and (max-width: $screen-mobile) {
      margin-top: 33px;
    }
  }
  &-card {
    background-color: var(--card-shop-bg);
    border-color: var(--card-shop-shadow);
    padding: 1.125rem;
    border-radius: 10px;
    margin-bottom: 15px;
    &:last-child {
      margin-bottom: 0;
    }
    @media screen and (max-width: $screen-mobile) {
      padding: 2.125rem 1rem;
      width: 100%;
    }
    &-title {
      font-size: 16px;
      font-weight: 500;
      color: var(--text);
      margin-bottom: 0;
      span {
        display: block;
        font-size: 14px;
        color: var(--text);
        font-weight: 400;
      }
    }
    &-content {
      display: flex;
      flex-direction: column;
      gap: 16px;
      color: var(--text);
      &-form {
        display: flex;
        flex-direction: row;
        gap: 16px;
        padding: 0 15px;
        @media screen and (max-width: $screen-mobile) {
          padding: 0 10px;
        }
        .promotion-input {
          width: 256px;
        }
      }
    }
    .card {
      &-title {
        font-size: 24px;
        font-weight: 500;
        color: var(--text-active);
        margin-bottom: 8px;
        @media screen and (max-width: $screen-mobile) {
          font-size: 18px;
        }
      }
      &-description {
        font-size: 16px;
        font-weight: 400;
        color: var(--text);
        margin-bottom: 16px;
        padding-left: 20px;
      }
      &-details {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 60%;
        font-size: 24px;
        font-weight: 400;
        color: var(--text);
        margin-bottom: 2px;
        &:last-child {
          margin-bottom: 0;
        }
        span:first-child {
          font-weight: 500;
        }
        span {
          min-width: 25%;
          &.title {
            font-size: 16px;
            font-weight: 600;
            text-transform: uppercase;
          }
          &:last-child {
            color: var(--warning-light);
          }
        }
        @media screen and (max-width: $screen-mobile) {
          width: 100%;
          font-size: 18px;
        }
      }
    }
  }
  &-row {
    margin-bottom: 6px !important;
    @media screen and (max-width: $screen-mobile) {
      margin-bottom: 0 !important;
    }
    .promotion-card-flex {
      background-color: var(--card-shop-bg);
      border-color: var(--card-shop-shadow);
      padding: 1.125rem;
      border-radius: 10px;
      margin-bottom: 15px;
      position: relative;
      height: 100% !important;
      &:last-child {
        margin-bottom: 0;
      }
      @media screen and (max-width: $screen-mobile) {
        padding: 2.125rem 1rem;
        width: 100%;
      }
      .raffle-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        &.min-width {
          min-width: 227px;
        }
        &.max-width {
          max-width: 340px;
          min-width: 340px;
          overflow: hidden;
        }
        &-image {
          width: 80px;
          height: 80px;
          background-color: var(--promotions-item-number);
          border-radius: 10px;
          @media screen and (max-width: $screen-mobile) {
            width: 65px;
            height: 65px;
          }
          .anticon {
            font-size: 48px;
            color: var(--text-active);
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            @media screen and (max-width: $screen-mobile) {
              font-size: 36px;
            }
          }
          .custom-image {
            font-size: 48px;
            color: var(--text-active);
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            @media screen and (max-width: $screen-mobile) {
              font-size: 36px;
            }
          }
        }
        &-content {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          gap: 4px;
          &-title {
            font-size: 18px;
            font-weight: 500;
            color: var(--text);
            &2 {
              font-size: 16px;
              font-weight: 400;
              color: var(--text);
              margin-bottom: 0;
              @media screen and (max-width: $screen-mobile) {
                font-size: 14px;
              }
            }
            @media screen and (max-width: $screen-mobile) {
              font-size: 16px;
            }
          }
          &-subtitle {
            font-size: 14px;
            font-weight: 400;
            color: var(--text);
          }
          &-prize {
            font-size: 24px;
            font-weight: 600;
            color: var(--text-active);
            background-color: var(--promotions-item-number);
            padding-left: 8px;
            padding-right: 8px;
            border-radius: 10px;
            text-align: center;
            width: 100%;
            @media screen and (max-width: $screen-mobile) {
              font-size: 18px;
              width: 90%;
            }
          }
        }
        &-times {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          &-title {
            font-size: 16px;
            font-weight: 500;
            color: var(--text);
            margin-bottom: 8px;
          }
          &-content {
            display: flex;
            flex-direction: row;
            gap: 16px;
            &-times {
              display: flex;
              flex-direction: column;
              align-items: center;
              background-color: var(--promotions-item-number);
              border-radius: 10px;
              padding: 8px;
              width: 65px;
              height: 65px;
              line-height: 1.3;
              position: relative;
              &-value {
                font-size: 24px;
                font-weight: 600;
                color: var(--text-active);
              }
              &-label {
                font-size: 14px;
                font-weight: 400;
                color: var(--text);
              }
              &:not(:last-child) {
                &::after {
                  content: ":";
                  font-size: 24px;
                  font-weight: 600;
                  color: var(--text-active);
                  position: absolute;
                  right: -10px;
                  top: 50%;
                  transform: translateY(-50%);
                }
              }
            }
          }
        }
      }
      .raffle-last-winner {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;
        &-title {
          font-size: 16px;
          font-weight: 500;
          color: var(--text);
        }
        &-content {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          gap: 8px;
          &-image {
            width: 65px;
            height: 65px;
            background-color: var(--promotions-item-number);
            border-radius: 10px;
            .anticon {
              font-size: 48px;
              color: var(--text-active);
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              height: 100%;
            }
          }
          &-info {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 4px;
            &-name {
              font-size: 16px;
              font-weight: 400;
              color: var(--text);
            }
            &-prize {
              font-size: 18px;
              font-weight: 600;
              color: var(--text-active);
              background-color: var(--promotions-item-number);
              padding-left: 8px;
              padding-right: 8px;
              border-radius: 10px;
              text-align: center;
              width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
@import "~@/assets/scss/variable";
.promotion {
  .ant-table {
    &:hover {
      transition: 0.5s ease;
      background: unset;
    }
    tr.ant-table-row:hover {
      transition: 0.5s ease;
      background: var(--table-hover) !important;
    }
    tr:nth-child(2n) {
      transition: 0.5s ease;
      background: var(--table-striped) !important;
    }
    tr.table-row-disabled,
    tr.table-row-disabled:hover {
      color: var(--table-disabled) !important;
      background: var(--table-disabled) !important;
      font-weight: 600;
    }
    .ant-table-tbody > tr.ant-table-row:hover > td {
      transition: 0.5s ease;
      background: none !important;
    }
    &-tbody,
    &-thead {
      color: var(--text) !important;
      tr {
        th {
          color: var(--text) !important;
          background-color: transparent !important;
        }
      }
    }
    &-footer {
      background: transparent;
    }
    .action-button-view {
      color: var(--btn-text-secondary);
      border-color: var(--btn-bc-secondary);
      background-color: var(--btn-bg-secondary);
      transition: all 0.5s ease;
      &:hover {
        color: var(--btn-text-secondary);
        border-color: var(--btn-bc-secondary);
        background-color: var(--btn-bg-secondary);
        transition: all 0.5s ease;
      }
    }
    .ant-table-placeholder {
      background: var(--card-bg);
      color: var(--text);
      border-radius: 0;
    }
    @media screen and (max-width: $screen-mobile) {
      &-small {
        border: none;
      }
      &-body {
        margin: 0 1px;
      }
    }
  }
  .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination-next .ant-pagination-item-link {
    color: var(--btn-text-secondary) !important;
    background-color: var(--btn-bg-secondary) !important;
    border-color: var(--btn-bc-secondary) !important;
  }
  .ant-table-pagination.mini {
    .ant-pagination-prev .ant-pagination-item-link,
    .ant-pagination-next .ant-pagination-item-link {
      background-color: transparent !important;
      border-color: none !important;
      color: var(--text) !important;
    }
  }
  .ant-pagination-item {
    color: var(--btn-text-secondary) !important;
    background-color: var(--btn-bg-secondary) !important;
    border-color: var(--btn-bc-secondary) !important;
    a {
      color: var(--btn-text-secondary) !important;
    }
    &-active {
      color: var(--btn-text-primary) !important;
      background-color: var(--btn-bg-primary) !important;
      border-color: var(--btn-bc-primary) !important;
      a {
        color: var(--btn-text-primary) !important;
      }
    }
  }
  .ant-pagination {
    color: var(--text) !important;
  }
  .ant-form label {
    color: var(--text);
    font-family: "Roboto", sans-serif;
  }
  .ant-input-number,
  .ant-input {
    background-color: var(--input-bg);
    color: var(--text);
    &:active,
    &:focus,
    &:hover {
      border-color: var(--text-active);
    }
  }
  .ant-input-affix-wrapper {
    .ant-input:not(:first-child) {
      padding-left: 2.8125rem;
    }
    .ant-input-prefix {
      color: var(--text);
      font-size: 1.375rem;
      font-family: "Roboto", sans-serif;
    }
    .ant-input-clear-icon,
    .ant-input-textarea-clear-icon,
    .ant-input-password-icon {
      color: var(--text);
    }
  }
  .has-error .ant-input-affix-wrapper .ant-input,
  .has-error .ant-input-affix-wrapper .ant-input:hover {
    background-color: color(--input-bg);
  }
  .list-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    &-head {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      gap: 6px;
      &-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 2px;
        max-width: 70%;
        width: 70%;
        overflow: hidden;
        &-name {
          span {
            font-size: 16px;
            font-weight: 600;
            text-overflow: ellipsis;
          }
        }
      }
      &-footer {
        max-width: 30%;
        width: 30%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        gap: 2px;
        &-status {
          width: 100%;
          span {
            width: 100%;
            font-size: 14px;
            font-weight: 600;
            &.success {
              color: var(--success);
            }
            .anticon {
              margin-right: 6px;
            }
          }
          &:first-child {
            span {
              font-size: 16px;
            }
          }
        }
      }
    }
    &-actions {
      width: 100%;
      margin-top: 10px;
      .ant-btn-group {
        width: 100%;
        .more-info-button,
        .view-button,
        .cancel-button {
          width: 100%;
        }
        .more-info-button {
          color: var(--btn-text-secondary);
          border-color: var(--btn-bc-secondary);
          border-right-color: var(--btn-bc-secondary);
          background-color: var(--btn-bg-secondary);
          &:active,
          &:focus,
          &:hover {
            color: var(--btn-text-secondary);
            border-color: var(--btn-bc-secondary);
            border-right-color: var(--btn-bc-secondary);
            background-color: var(--btn-bg-secondary);
          }
        }
        .view-button {
          color: var(--btn-text-primary);
          border-color: var(--btn-bc-primary);
          background-color: var(--btn-bg-primary);
          &:active,
          &:focus,
          &:hover {
            color: var(--btn-text-primary);
            border-color: var(--btn-bc-primary);
            background-color: var(--btn-bg-primary);
          }
        }
      }
    }
  }
}
.custom-promotion-modal {
  * {
    .ant-modal-content {
      background-color: var(--modal-bg) !important;
    }
    .ant-modal-confirm-body {
      margin-right: 0;
      .anticon {
        color: var(--tertiary) !important;
      }
      .ant-modal-confirm-content {
        margin: 0 !important;
        padding: 0 !important;
        margin-top: 10px !important;
        text-align: center;
        font-size: 16px;
        color: var(--text);
      }
      .ant-modal-confirm-title {
        font-size: 18px;
        font-weight: 500;
        color: var(--text);
        margin-bottom: 0;
      }
      .ant-table,
      .ant-table-thead > tr > th {
        color: var(--text) !important;
      }
      .ant-table {
        tr.ant-table-row:hover {
          transition: 0.5s ease;
          background: var(--table-hover) !important;
        }
        .ant-table-tbody > tr.ant-table-row:hover > td {
          transition: 0.5s ease;
          background: none !important;
        }
      }
    }
    .ant-modal-confirm-btns {
      .ant-btn-default {
        color: var(--btn-text-secondary);
        background-color: var(--btn-bg-secondary);
        border: 1px solid var(--btn-bc-secondary);
        &:hover,
        &:active,
        &:focus {
          background-color: transparent;
        }
      }
    }
  }
}
.promotion-card-flex {
  .ant-card-body {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    .raffle-item:last-child {
      border-left: 1px solid var(--card-shop-shadow);
      padding-left: 16px;
    }
    @media screen and (max-width: $screen-mobile) {
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .raffle-item:last-child {
        border-left: none;
        padding-left: 0;
        border-top: 1px solid var(--card-shop-shadow);
        padding-top: 16px;
        width: 100%;
        text-align: center;
        justify-content: center;
      }
    }
  }
  .raffle-item-arrows {
    position: absolute;
    top: 50%;
    left: 16px;
    right: 16px;
    display: flex;
    justify-content: space-between;
    transform: translateY(-50%);
    pointer-events: none;
    .raffle-item-arrow {
      font-size: 24px;
      color: var(--text-active);
      pointer-events: auto;
      cursor: pointer;
      &:hover {
        color: var(--text);
      }
      &.disabled {
        color: var(--text-disabled);
        cursor: not-allowed;
      }
    }
  }
}
</style>
